import React, { useState } from "react";
import VideosPopUp from "../../organisms/videos-popup/videos-popup";
import videoPlayer from "../../../assets/images/icon-play.png";

import "./featuredVideo.scss";

export interface IFeaturedVideo {
  titulo: string;
  descripcion: string;
  actualVideo: {
    imagen: string;
    video: string;
  }[];
}

const FeaturedVideo = (props: IFeaturedVideo) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const { actualVideo, titulo, descripcion } = props;
  return (
    <div className="video">
      <div className="video__container">
        <div className="video__container-text">
          <h2>{titulo}</h2>
          <p>{descripcion}</p>
        </div>
      </div>
      <div className="video__container-content">
        <VideosPopUp
          setShowPopUp={setShowPopUp}
          showPopUp={showPopUp}
          actualVideo={actualVideo[0]}
        />
        <img
          src={actualVideo[0].imagen}
          className="video__container-content-imagen"
          alt=""
          onClick={() => setShowPopUp(true)}
        />
        <img
          src={videoPlayer}
          alt=""
          className="video__container-content-icon-play"
          onClick={() => setShowPopUp(true)}
        />
      </div>
    </div>
  );
};

export default FeaturedVideo;
